export default {
  title: '集体评分',
  paper: '试题',
  scoreStatus: '评分标准',
  table: {
    name: '姓名',
    number: '编号',
    score: '得分',
    average: '平均成绩',
    class: '等级',
    comment: '评语',
    examScore: '考试成绩',
    viewPaper: '查看考卷',
    noData: '暂无信息',
    min: '最小值',
    max: '最大值',
    point: '{number}分',
    halfPoint: '半分',
    fullPoint: '满分',
    setScore: '打分',
    edit: '编辑',
  },
  dialogTitle: '面试官评语',
  remarkPlaceholder: '请输入内容',
  cancel: '取 消',
  confirm: '确 定',
  imagePreview: '图片预览',
  checkInTips: '该候选人尚未签到，请先给该候选人签到。',
  goCheckIn: '去给候选人签到',
  checkInComment: '只评已签到候选人',
  // checkStatusWaiting: "该候选人面试尚未开始",
  checkStatusWaiting: '您还未开始评分，是否立即开始？',
  checkStatusComplete: '面试已结束，修改成绩请返回列表页点击单个候选人修改',
  error307: '您已被管理员结束打分，点击确定后，将跳转到首页',
  noPaperAlert: {
    title: '提示',
    msg: '当前无有效试题！',
    expired: '原内容已失效，本次将打开新的内容，新内容有效时间为',
  },
  noPaper: '暂无试题',
  operateContent: {
    waiting: '开始评分',
    interviewing: '完成',
  },
  stateContent: {
    interviewing: '评分进行中',
    complete: '修改成绩请返回列表页点击单个候选人修改',
  },
  exceedMaximumScore: '评分分值不符合预设分值。',
  viewQuestions: '查看试题',
  closeQuestions: '关闭试题',
  notDrawnPaper: '尚未抽题',
  scoreSheet: '评分表',
  questionsTab: '试题',
  noQuestions: '暂无试题',
  singleRating: '单人评分',
  groupRating: '集体评分',
  selectRatingMode: '选择评分方式',
  candidateInfoTitle: '候选人信息',
  viewAttachment: '查看此附件',
  genderMale: '男',
  genderFemale: '女',
};
